import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, ShieldAlert, ArrowRight, X } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { getNotifications } from "@/lib/api";

export default function PendingOrgBanner() {
  const { user } = useAuth();
  const [pendingCount, setPendingCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  const isSuperAdmin =
    user?.role === "super_admin" ||
    (Array.isArray(user?.roles) && user.roles.includes("super_admin")) ||
    ["super_admin", "regional_admin", "financials_admin"].includes(user?.role);

  useEffect(() => {
    if (!isSuperAdmin) return;
    let isCancelled = false;

    const fetchAlerts = async () => {
      try {
        const data = await getNotifications();
        if (!isCancelled) {
          setPendingCount(data.pending_orgs_count || 0);
          setNotifications(data.notifications || []);
        }
      } catch (err) {
        // Silent catch if user is not super admin or offline
      }
    };

    fetchAlerts();
    const interval = setInterval(fetchAlerts, 30000); // refresh every 30s
    return () => {
      isCancelled = true;
      clearInterval(interval);
    };
  }, [isSuperAdmin]);

  if (!isSuperAdmin || dismissed || pendingCount <= 0) return null;

  return (
    <div className="bg-gradient-to-r from-amber-500/15 via-amber-500/10 to-amber-500/15 border-b border-amber-500/30 px-4 py-2.5 text-xs text-amber-900 dark:text-amber-200">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <div className="p-1 rounded-full bg-amber-500/20 text-amber-600 dark:text-amber-400 shrink-0">
            <ShieldAlert className="h-4 w-4" />
          </div>
          <span className="font-medium">
            Action Required: <span className="font-semibold text-amber-700 dark:text-amber-300">{pendingCount} organization registration(s)</span> pending super admin approval.
          </span>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <Link
            to="/mission-control"
            className="inline-flex items-center gap-1 px-3 py-1 rounded-md bg-amber-600 hover:bg-amber-700 text-white font-medium shadow-sm transition-colors"
          >
            Review & Approve <ArrowRight className="h-3 w-3" />
          </Link>
          <button
            onClick={() => setDismissed(true)}
            className="p-1 rounded text-amber-700/70 hover:text-amber-900 dark:text-amber-400 hover:bg-amber-500/20 transition-colors"
            title="Dismiss banner"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
